/* ob-tiroir.js — tiroir panier natif (remplace le tiroir Moon Bundles ; bascule du 22-23/10).
   Rendu : modèles découpés dans les gabarits relevés sur le tiroir Moon (snippets/ob-tiroir.liquid), remplis avec
   /cart.js : ce que la cliente voit est ce que Shopify calcule (prix payés, réductions), jamais un prix inventé.
   Panier : après chaque changement (fiche, tiroir, page panier, autre appli), le thème
     1. ajuste les cadeaux (copies à 0 €) : offerts selon la règle Moon (découpage de la quantité en paliers, le plus
        grand d'abord ; chaque lot apporte les cadeaux de son palier), retirés quand le palier n'est plus atteint,
        remis quand il l'est de nouveau ;
     2. pose les codes « hors palier » (prix Moon d'une quantité hors palier) et les codes des upsells du tiroir, en
        gardant les codes de la cliente (Klaviyo…).
   Comportements repris du tiroir Moon et de son code perso (bienfaits, badge −X %, prix barrés réécrits, correctif
   K-Lift, minuteur qui recommence). */
(function () {
  'use strict';
  if (window.ObTiroir) return;
  var racine = document.getElementById('ob-tiroir');
  var cfgEl = document.getElementById('ob-tiroir-config');
  if (!racine || !cfgEl) return;

  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { if (window.console) console.error('ob-tiroir config', e); return; }
  var S = C.statique, K = S.classes;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var Z = String.fromCharCode(8288);          // gluon invisible ajouté par le code perso Moon aux montants réécrits
  var MOINS = '−';
  var fetchOrigine = window.fetch.bind(window);

  // ---------- données ----------
  // une copie à couleurs (pyjama Rose / Blanc, 23/10) a une variante par couleur (c.variantes) et un réel par couleur
  // (c.reels) : chaque variante est reconnue comme copie de sa clé, et son unité payée est le réel de SA couleur
  var copies = {}, copieParVariante = {}, reelProduitDeCopie = {}, reelDeCopie = {};
  Object.keys(C.copies || {}).forEach(function (cle) {
    var c = C.copies[cle];
    if (c && c.variante) {
      copies[cle] = c;
      (c.variantes || [c]).forEach(function (v) {
        if (!v || !v.variante) return;
        copieParVariante[v.variante] = cle;
        if (c.reel_produit) reelProduitDeCopie[v.variante] = c.reel_produit;
        reelDeCopie[v.variante] = (c.reels && c.reels[v.titre]) || v.reel || c.reel;
      });
    }
  });
  var upsells = (C.upsells || []).filter(function (u) { return u && u.variante; });
  var option = C.option && C.option.variante ? C.option : null;
  var cleParReel = {};
  Object.keys(copies).forEach(function (cle) {
    var c = copies[cle];
    if (c.reel) cleParReel[c.reel] = cle;
    Object.keys(c.reels || {}).forEach(function (t) { if (c.reels[t]) cleParReel[c.reels[t]] = cle; });
  });
  var codesOb = {};
  (S.codes_ob || []).forEach(function (c) { codesOb[c.toLowerCase()] = 1; });
  var barres = {};
  Object.keys(C.barres || {}).forEach(function (k) { if (/^\d+$/.test(k)) barres[k] = C.barres[k]; });
  Object.keys(copies).forEach(function (k) {
    (copies[k].variantes || [copies[k]]).forEach(function (v) {
      if (v && v.variante && (v.barre || copies[k].barre)) barres[v.variante] = v.barre || copies[k].barre;
    });
  });
  upsells.forEach(function (u) { if (u.barre) barres[u.variante] = u.barre; });
  if (option && option.barre) barres[option.variante] = option.barre;
  var barresChargees = {};

  function cloner(nom) {
    var t = document.querySelector('template[data-obt-modele="' + nom + '"]');
    return t ? document.importNode(t.content, true) : document.createDocumentFragment();
  }
  function q(el, cle) { return el ? el.querySelector('[data-obt="' + cle + '"]') : null; }
  function qa(el, cle) { return el ? [].slice.call(el.querySelectorAll('[data-obt="' + cle + '"]')) : []; }

  // ---------- montants : format Moon « €{{amount_with_comma_separator}} » ----------
  function fmt(c) {
    c = Math.round(c || 0);
    var neg = c < 0; c = Math.abs(c);
    var e = Math.floor(c / 100), d = String(c % 100);
    if (d.length < 2) d = '0' + d;
    return (neg ? '-' : '') + '€' + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d;
  }

  // ---------- réseau ----------
  var INTERNE = 'X-Ob-Tiroir';
  function appel(chemin, corps) {
    var o = { method: corps ? 'POST' : 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin' };
    o.headers[INTERNE] = '1';
    if (corps) { o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(corps); }
    if (!corps) o.cache = 'no-store';
    // par window.fetch (et non la copie d'origine) : un script posé après nous (pixels de Shopify, autre appli) voit aussi
    // nos ajouts ; notre propre interception reconnaît l'en-tête interne et laisse passer
    etat.reseau = (etat.reseau || 0) + 1;
    majOccupe();
    var fin = function () { etat.reseau--; majOccupe(); };
    return window.fetch(ROOT + chemin.replace(/^\//, ''), o).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || (j && j.status && j.status >= 400)) throw j; return j; });
    }).then(function (j) { fin(); return j; }, function (e) { fin(); throw e; });
  }

  // ---------- règle Moon des cadeaux ----------
  function cadeauxOfferts(pid, qte) {
    var paliers = (C.cadeaux || {})[pid];
    var n = {};
    if (!paliers) return n;
    var r = qte;
    paliers.forEach(function (t) {           // paliers triés du plus grand au plus petit
      while (r >= t.q) {
        r -= t.q;
        t.cadeaux.forEach(function (cle) { n[cle] = (n[cle] || 0) + 1; });
      }
    });
    return n;
  }

  function estOption(it) { return !!(option && it.variant_id === option.variante) || !!(it.properties && it.properties._ob_option); }
  function estCopie(it) { return copieParVariante[it.variant_id] !== undefined; }
  // un panier fait avec Moon avant la bascule : ses upsells du tiroir gardent leur prix, ses cadeaux deviennent nos copies
  function estUpsellTiroir(it) { return it.properties && (it.properties._ob_upsell || it.properties._moonBundleCart === 'upsell'); }
  // « gift » = cadeau Moon ; « upsell » = l'upsell coché d'un bundle Moon (le masque offert du sérum collagène, 100 % chez
  // Moon) : converti lui aussi quand une copie à 0 € existe pour ce produit, sinon il serait facturé une fois Moon coupé
  function estCadeauMoon(it) {
    var v = it.properties && it.properties.__moonbundle;
    if (!v) return false;
    try {
      var t = JSON.parse(v).type;
      return t === 'gift' || (t === 'upsell' && !!cleParReel[it.variant_id]);
    } catch (e) { return false; }
  }
  function produitMoon(it) {
    try { return String(JSON.parse(it.properties.__moonbundle).main_product_id || ''); } catch (e) { return ''; }
  }

  function quantitesParProduit(cart) {
    var n = {};
    cart.items.forEach(function (it) {
      if (estCopie(it) || estOption(it) || estCadeauMoon(it)) return;
      n[it.product_id] = (n[it.product_id] || 0) + it.quantity;
    });
    return n;
  }

  function quantitesUpsell(cart) {
    var n = {};
    cart.items.forEach(function (it) {
      if (estUpsellTiroir(it) && !estCopie(it) && !estCadeauMoon(it)) n[it.product_id] = (n[it.product_id] || 0) + it.quantity;
    });
    return n;
  }

  // upsell du tiroir + le même produit : le code de la règle de Moon, S.upsell_n[produit][unités hors upsell], quand il
  // bat la meilleure réduction automatique de la quantité totale (sinon Shopify applique l'automatique)
  function codeUpsellN(pid, qp, upQ) {
    var e = ((S.upsell_n || {})[pid] || {})[(qp[pid] || 0) - (upQ[pid] || 0)];
    return e && e[1] > meilleureAuto(pid, qp[pid] || 0) ? e : null;
  }

  // règle de Moon MESURÉE le 22/10 (draftOrderCalculate) : la ligne d'upsell du tiroir ne compte pas dans le palier qui
  // offre un cadeau (3 tubes + 1 venu de l'upsell : le K-Lift n'est pas offert), même quand l'automatique de la quantité
  // totale fixe le prix
  function autorises(cart) {
    var qp = quantitesParProduit(cart), upQ = quantitesUpsell(cart), a = {};
    Object.keys(qp).forEach(function (pid) {
      var o = cadeauxOfferts(pid, qp[pid] - (upQ[pid] || 0));
      Object.keys(o).forEach(function (cle) { a[cle] = (a[cle] || 0) + o[cle]; });
    });
    return a;
  }

  function autoriseCopie(cart, cle) { return autorises(cart)[cle] || 0; }
  // les unités d'une clé de cadeau dans le panier, toutes lignes et toutes couleurs
  function totalCle(cart, cle) {
    var n = 0;
    cart.items.forEach(function (it) { if (copieParVariante[it.variant_id] === cle) n += it.quantity; });
    return n;
  }

  function lireRetires(cart) {
    try { return JSON.parse((cart.attributes || {})._ob_cadeaux_retires || '{}') || {}; } catch (e) { return {}; }
  }

  function meilleureAuto(pid, q) {
    var m = 0;
    ((S.remises_auto || {})[pid] || []).forEach(function (r) { if (q >= r[0] && r[1] > m) m = r[1]; });
    return m;
  }

  /* ce que le panier doit devenir : quantités des lignes cadeaux, cadeaux à remettre, codes */
  function plan(cart) {
    var qp = quantitesParProduit(cart), upQ = quantitesUpsell(cart);
    var autorise = autorises(cart);
    var retires = lireRetires(cart), retires0 = JSON.stringify(retires);
    var maj = {}, ajouts = [], presents = {};
    // lignes cadeaux : on réduit en partant de la dernière ligne
    var parCle = {};
    cart.items.forEach(function (it) {
      var cle = copieParVariante[it.variant_id];
      if (cle === undefined) return;
      (parCle[cle] = parCle[cle] || []).push(it);
    });
    Object.keys(parCle).forEach(function (cle) {
      var lignes = parCle[cle], total = 0;
      lignes.forEach(function (it) { total += it.quantity; });
      presents[cle] = total;
      var a = autorise[cle] || 0;
      if (total > a) {
        var trop = total - a;
        retires[cle] = (retires[cle] || 0) + trop;
        // la variante de chaque unité retirée (sa couleur), dans l'ordre du retrait : remise telle quelle au retour du palier
        var memo = retires['@' + cle] = [].concat(retires['@' + cle] || []);
        for (var i = lignes.length - 1; i >= 0 && trop > 0; i--) {
          var enlever = Math.min(trop, lignes[i].quantity);
          maj[lignes[i].key] = lignes[i].quantity - enlever;
          for (var u = 0; u < enlever; u++) memo.push(lignes[i].variant_id);
          trop -= enlever;
        }
      }
    });
    // cadeaux Moon (panier d'avant la bascule) : la ligne part, la copie à 0 € la remplace si le palier y donne droit
    var produitsMoon = {};
    cart.items.forEach(function (it) {
      if (!estCadeauMoon(it)) return;
      maj[it.key] = 0;
      var cle = cleParReel[it.variant_id];
      if (cle) retires[cle] = (retires[cle] || 0) + it.quantity;
      var pm = produitMoon(it);
      if (pm) produitsMoon[pm] = 1;
    });
    // un cadeau d'une offre Moon changée depuis (le cadeau mystère du mascara, remplacé par le K-Lift le 22/10) n'a pas
    // de copie qui lui réponde : le palier de son produit donne ce qu'il offre aujourd'hui
    Object.keys(produitsMoon).forEach(function (pid) {
      Object.keys(cadeauxOfferts(pid, qp[pid] || 0)).forEach(function (cle) {
        var manque = (autorise[cle] || 0) - (presents[cle] || 0);
        if (manque > (retires[cle] || 0)) retires[cle] = manque;
      });
    });
    // cadeaux retirés par le thème : remis quand le palier est de nouveau atteint
    // (« @clé » : la variante des unités retirées, dernière retirée = première remise ; un panier d'avant n'en a pas :
    // la couleur par défaut)
    Object.keys(retires).forEach(function (cle) {
      if (cle.charAt(0) === '@') return;
      var manque = (autorise[cle] || 0) - (presents[cle] || 0);
      if (manque > 0 && retires[cle] > 0 && copies[cle]) {
        var n = Math.min(manque, retires[cle]);
        var memo = [].concat(retires['@' + cle] || []), pris = memo.splice(Math.max(0, memo.length - n), n);
        while (pris.length < n) pris.unshift(copies[cle].variante);
        var parV = {}, ordre = [];
        pris.forEach(function (v) { if (!parV[v]) { parV[v] = 0; ordre.push(v); } parV[v]++; });
        ordre.forEach(function (v) { ajouts.push({ id: v, quantity: parV[v], properties: { _ob_cadeau: '1' } }); });
        if (retires['@' + cle]) retires['@' + cle] = memo;
        retires[cle] -= n;
      }
      if (!(retires[cle] > 0)) delete retires[cle];
      if (!autorise[cle] && !presents[cle]) delete retires[cle];
    });
    Object.keys(retires).forEach(function (k) {
      if (k.charAt(0) === '@' && (!(retires[k.slice(1)] > 0) || !(retires[k] || []).length)) delete retires[k];
    });
    // l'option seule (plus aucun produit) : retirée
    var visibles = cart.items.filter(function (it) { return !estOption(it); });
    var restants = visibles.filter(function (it) { return maj[it.key] !== 0; });
    if (!restants.length && !ajouts.length) {
      cart.items.forEach(function (it) { if (estOption(it)) maj[it.key] = 0; });
    }
    // codes
    var voulus = [], cliente = [];
    (cart.discount_codes || []).forEach(function (d) {
      if (!codesOb[String(d.code).toLowerCase()]) cliente.push(d.code);
    });
    // upsell du tiroir + le même produit (règle de Moon mesurée le 22/10) : la ligne d'upsell paie son prix moins la
    // remise, les AUTRES unités du produit suivent les paliers sur leur propre quantité n → un seul code par produit,
    // S.upsell_n[produit][n] = [code, montant], à la place du code hors palier ; posé seulement s'il bat la meilleure
    // réduction automatique de la quantité totale (sinon Shopify le refuse avec un message au paiement, et l'automatique,
    // moins chère que Moon, s'applique de toute façon)
    var hp = [];
    Object.keys(qp).forEach(function (pid) {
      if (upQ[pid]) return;
      var t = (S.hors_palier || {})[pid];
      if (t && t[qp[pid]]) hp.push(t[qp[pid]]);
    });
    var up = {};
    Object.keys(upQ).forEach(function (pid) {
      var e = codeUpsellN(pid, qp, upQ);
      if (e) up[e[0]] = 1;
    });
    voulus = cliente.concat(hp, Object.keys(up));
    var max = S.max_codes || 5;
    if (voulus.length > max) voulus = voulus.slice(0, max);
    var actuels = (cart.discount_codes || []).map(function (d) { return String(d.code).toLowerCase(); }).sort().join('\n');
    var cible = voulus.map(function (c) { return c.toLowerCase(); }).sort().join('\n');
    var attr = JSON.stringify(retires);
    return { maj: maj, ajouts: ajouts, codes: actuels !== cible ? voulus : null, attributs: attr !== retires0 ? attr : null };
  }

  // panier fait avec Moon : sa ligne d'upsell du tiroir devient la nôtre (_ob_upsell). Notre code s'y applique et la
  // remise du tiroir Moon — laissée active jusqu'au départ de Moon pour les liens de reprise qui vont droit au paiement —
  // ne la vise plus (deux remises égales : notre code serait refusé avec un message)
  function convertirUpsellsMoon(cart) {
    var a = cart.items.filter(function (it) {
      return it.properties && it.properties._moonBundleCart === 'upsell' && !it.properties._ob_upsell;
    });
    if (!a.length) return Promise.resolve(cart);
    return a.reduce(function (pr, it) {
      return pr.then(function () {
        return appel('cart/change.js', { id: it.key, quantity: it.quantity, properties: { _ob_upsell: '1' } });
      });
    }, Promise.resolve()).then(function () { return appel('cart.js'); });
  }

  function synchroniser(cart) {
    return convertirUpsellsMoon(cart).then(synchroniserPlan, function (e) {
      if (window.console) console.warn('ob-tiroir upsell Moon', e);
      return appel('cart.js').then(synchroniserPlan);
    });
  }

  function synchroniserPlan(cart) {
    var p = plan(cart);
    var travail = Promise.resolve(null), change = false;
    var corps = {};
    if (Object.keys(p.maj).length) { corps.updates = p.maj; change = true; }
    if (p.attributs !== null) { corps.attributes = { _ob_cadeaux_retires: p.attributs === '{}' ? '' : p.attributs }; change = true; }
    if (Object.keys(corps).length) travail = travail.then(function () { return appel('cart/update.js', corps); });
    // un cadeau refusé (copie indisponible) n'empêche jamais la pose des codes qui suit
    if (p.ajouts.length) {
      change = true;
      travail = travail.then(function () {
        return appel('cart/add.js', { items: p.ajouts }).catch(function (e) { if (window.console) console.warn('ob-tiroir cadeau refusé', e); });
      });
    }
    if (p.codes) {
      change = true;
      travail = travail.then(function () { return appel('cart/update.js', { discount: p.codes.join(',') }); });
    }
    if (!change) return Promise.resolve(cart);
    return travail.then(function () { return appel('cart.js'); }).then(function (c2) {
      // une seconde passe suffit toujours (les cadeaux ne changent pas les quantités des produits)
      var p2 = plan(c2);
      if (p2.codes && !p.codes) return appel('cart/update.js', { discount: p2.codes.join(',') }).then(function () { return appel('cart.js'); });
      return c2;
    }).then(function (c) { notifierTheme(); return c; })
      .catch(function (e) { if (window.console) console.warn('ob-tiroir sync', e); return appel('cart.js'); });
  }

  // page panier du thème : elle se redessine quand nous avons changé le panier (codes, cadeaux)
  function notifierTheme() {
    try {
      if (document.getElementById('main-cart-items') && typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ob-tiroir' });
      }
    } catch (e) { /* à jour au prochain affichage */ }
  }

  // ---------- prix barrés (comme Moon : max(prix barré Shopify, prix d'origine, prix payé)) ----------
  function chargerBarres(cart) {
    var manquants = {};
    cart.items.forEach(function (it) {
      if (barres[it.variant_id] === undefined && !barresChargees[it.handle] && !estCopie(it)) manquants[it.handle] = 1;
    });
    var hs = Object.keys(manquants);
    if (!hs.length) return Promise.resolve();
    return Promise.all(hs.map(function (h) {
      barresChargees[h] = 1;
      return fetchOrigine(ROOT + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          p.variants.forEach(function (v) { barres[v.id] = v.compare_at_price || 0; });
        }).catch(function () {});
    }));
  }

  function prixOrigineUnitaire(it) {
    var b = barres[it.variant_id] || 0;
    var o = Math.round((it.original_line_price || 0) / (it.quantity || 1));
    var f = Math.round((it.final_line_price || 0) / (it.quantity || 1));
    return Math.max(b, o, f);
  }

  // ---------- état ----------
  var etat = { cart: null, ouvert: false, iu: 0, coque: null, minuteurT: null, enCours: 0, enAttente: null };

  function lignesAffichees(cart) { return cart.items.filter(function (it) { return !estOption(it); }); }

  // ---------- rendu ----------
  function rendre() {
    var cart = etat.cart;
    var contenu = q(racine, 'contenu');
    if (!cart || !contenu) return;
    var aff = lignesAffichees(cart);
    if (!aff.length) {
      if (etat.coque !== 'vide') {
        contenu.innerHTML = '';
        contenu.appendChild(cloner('vide'));
        etat.coque = 'vide';
      }
      majOuverture();
      return;
    }
    if (etat.coque !== 'plein') {
      contenu.innerHTML = '';
      contenu.appendChild(cloner('plein'));
      etat.coque = 'plein';
    }
    var nb = 0;
    aff.forEach(function (it) { nb += it.quantity; });
    texte(q(contenu, 'nb'), String(nb));
    majMinuteur();

    // lignes
    var boite = q(contenu, 'lignes');
    var frag = document.createDocumentFragment();
    var origTotal = 0, corrK = 0;
    var qp = quantitesParProduit(cart), autorise = autorises(cart);
    cart.items.forEach(function (it) {
      var origLigne = prixOrigineUnitaire(it) * it.quantity;
      if (estOption(it)) { origTotal += origLigne; return; }
      var cle = copieParVariante[it.variant_id];
      var cad = cle !== undefined;
      var el = cloner(cad ? 'cadeau' : 'ligne').firstElementChild;
      el.setAttribute('data-item-key', it.key);
      var img = q(el, 'l-img');
      if (img) {
        var src = it.image || (it.featured_image && it.featured_image.url) || '';
        if (src) img.setAttribute('src', src); else img.removeAttribute('src');
        img.setAttribute('alt', it.product_title || '');
      }
      texte(q(el, 'l-titre'), it.product_title || '');
      var opts = q(el, 'l-options');
      if (opts) {
        var val = it.product_has_only_default_variant ? '' :
          (it.options_with_values || []).map(function (o) { return o.value; }).join(' / ') || it.variant_title || '';
        if (val) texte(q(el, 'l-options-val'), val); else opts.parentNode.removeChild(opts);
      }
      var inp = q(el, 'l-qte');
      if (inp) { inp.setAttribute('value', String(it.quantity)); inp.value = String(it.quantity); }
      bouton(q(el, 'l-moins'), it.quantity > 1);
      // « + » actif, même sur un cadeau (comme Moon), jusqu'à 10 unités du produit : au-delà, plus de code hors palier et le
      // prix sauterait (11 sérums mascara : 289,35 € au lieu de 129,85 €)
      var pidL = cad ? reelProduitDeCopie[it.variant_id] : it.product_id;
      bouton(q(el, 'l-plus'), !((qp[pidL] || 0) >= (S.qmax || 10)));
      var prix = it.final_line_price;
      var orig = origLigne, a = 0;
      // correctif K-Lift (code perso Moon du 09/10) : lot « 1 acheté = 1 offert » barré à 59,80 € au lieu de 2 × 49,90 €
      if (!cad && S.klift && it.variant_id === S.klift.variante) {
        var qq = orig / S.klift.K, k = qq - prix / S.klift.U;
        if (qq >= 2 && qq % 1 === 0 && k >= 1 && k % 1 === 0 && 2 * k <= qq) a = k * (S.klift.L - 2 * S.klift.K);
      }
      origTotal += orig;
      corrK += a;
      var o2 = orig + a;
      var pb = q(el, 'l-barre'), pr = q(el, 'l-remise');
      texte(q(el, 'l-prix'), fmt(prix));
      if (o2 > prix) texte(pb, fmt(o2) + (a ? Z : '')); else retirer(pb);
      if (cad) {
        texte(q(el, 'l-offert'), S.textes.offert);
      } else if (o2 > prix) {
        texte(pr, S.textes.remise.replace('{{discount_amount}}', fmt(o2 - prix)) + (a ? Z : ''));
      } else retirer(pr);
      frag.appendChild(el);
    });
    boite.innerHTML = '';
    boite.appendChild(frag);

    // points forts (code perso Moon : 4 par produit reconnu, 2 chacun s'il y en a plusieurs)
    var bien = q(contenu, 'bienfaits');
    if (bien) {
      var textes = aff.map(function (it) { return (it.product_title || '') + ' ' + (it.variant_title || ''); });
      var m = (S.bienfaits || []).filter(function (b) {
        var re = new RegExp(b[0], 'i');
        return textes.some(function (t) { return re.test(t); });
      });
      var n = m.length > 1 ? 2 : 4;
      var cleB = m.map(function (b) { return b[0]; }).join('|') + n;
      if (bien.getAttribute('data-k') !== cleB) {
        bien.innerHTML = '';
        m.forEach(function (b) {
          b[1].slice(0, n).forEach(function (p) {
            var s = cloner('bienfait').firstElementChild;
            var ic = q(s, 'b-icone');
            if (ic) {
              ic.innerHTML = S.icones[p[0]] || '';
              if (K.bienfait_trace) [].forEach.call(ic.children, function (x) { x.setAttribute('class', K.bienfait_trace); });
            }
            s.appendChild(document.createTextNode(p[1]));
            bien.appendChild(s);
          });
        });
        bien.setAttribute('data-k', cleB);
        bien.className = m.length ? K.bienfaits_plein : K.bienfaits_vide;
      }
    }

    rendreUpsells(contenu, cart);
    rendreOption(contenu, cart);

    // pied : « Vous économisez », sous-total (barré = somme des prix d'origine, comme Moon)
    var final = cart.total_price;
    var origT = origTotal + corrK;
    var eco = q(contenu, 'economie');
    if (eco) {
      cacher(eco, !(origT - final > 0));
      texte(q(contenu, 'economie-val'), '-' + fmt(origT - final) + (corrK ? Z : ''));
    }
    var stb = q(contenu, 'st-barre');
    if (stb) {
      cacher(stb, !(origT > final));
      texte(stb, fmt(origT) + (corrK ? Z : ''));
    }
    texte(q(contenu, 'st-final'), fmt(final));
    majOuverture();
  }

  function rendreUpsells(contenu, cart) {
    var bloc = q(contenu, 'upsell');
    if (!bloc) return;
    var dans = {};
    cart.items.forEach(function (it) {
      dans[it.product_id] = 1;
      if (reelProduitDeCopie[it.variant_id]) dans[reelProduitDeCopie[it.variant_id]] = 1;
    });
    var liste = upsells.filter(function (u) { return u.dispo !== false && !dans[u.produit]; });
    if (!liste.length) { cacher(bloc, true); etat.listeUpsells = []; return; }
    cacher(bloc, false);
    cacher(q(bloc, 'nav'), liste.length < 2);
    var i = Math.min(etat.iu, liste.length - 1);
    if (i < 0) i = 0;
    etat.iu = i;
    var cartes = q(bloc, 'cartes');
    cartes.innerHTML = '';
    cartes.appendChild(carte(liste[i]));
    if (liste.length > 1) cartes.appendChild(carteSuivante(liste[(i + 1) % liste.length]));
    etat.listeUpsells = liste;
  }

  function prixUpsell(u) {
    var fin = Math.max(0, u.prix - (u.remise || 0));
    var barre = u.barre && u.barre > u.prix ? u.barre : u.prix;
    var reecrit = false;
    (S.reecritures || []).forEach(function (r) {
      if (!reecrit && new RegExp(r[0], 'i').test(u.titre) && barre === r[1] && fin === r[2]) { barre = r[3]; reecrit = true; }
    });
    return { fin: fin, barre: barre, reecrit: reecrit };
  }

  function carte(u) {
    var el = cloner('carte').firstElementChild;
    el.setAttribute('data-product-id', u.produit);
    el.setAttribute('data-variant-id', u.variante);
    var img = q(el, 'u-img');
    if (img) { if (u.image) img.setAttribute('src', u.image); img.setAttribute('alt', u.titre); }
    texte(q(el, 'u-titre'), u.titre);
    var st = q(el, 'u-sous-titre');
    if (u.sous_titre) texte(st, u.sous_titre); else retirer(st);
    var p = prixUpsell(u);
    var pb = q(el, 'u-barre'), pp = q(el, 'u-prix');
    texte(pp, fmt(p.fin));
    if (p.barre > p.fin) {
      texte(pb, fmt(p.barre) + (p.reecrit ? Z : ''));
      var pct = Math.floor((p.barre - p.fin) / p.barre * 100);
      if (pct >= 1) {
        var b = cloner('pourcent').firstElementChild;
        b.textContent = MOINS + pct + ' %';
        pp.parentNode.insertBefore(b, pp.nextSibling);
      }
    } else retirer(pb);
    texte(q(el, 'u-remise'), S.textes.remise.replace('{{discount_amount}}', fmt(u.remise || 0)));
    var btn = q(el, 'u-ajouter');
    if (btn) { btn.setAttribute('type', 'button'); btn.setAttribute('data-variante', u.variante); }
    return el;
  }

  function carteSuivante(u) {
    var el = cloner('carte-suivante').firstElementChild;
    el.setAttribute('data-product-id', u.produit);
    el.setAttribute('data-variant-id', u.variante);
    var img = q(el, 'u-img');
    if (img) { if (u.image) img.setAttribute('src', u.image); img.setAttribute('alt', u.titre); }
    return el;
  }

  function rendreOption(contenu, cart) {
    var sec = q(contenu, 'option');
    if (!sec) return;
    if (!option) { cacher(sec, true); return; }
    var coche = cart.items.some(estOption);
    var cas = q(sec, 'option-case'), cur = q(sec, 'option-curseur');
    if (cas) { cas.checked = coche; if (coche) cas.setAttribute('checked', ''); else cas.removeAttribute('checked'); }
    if (cur) cur.className = coche ? K.curseur_on : K.curseur_off;
    texte(q(sec, 'option-prix'), fmt(option.prix));
    var ob = q(sec, 'option-barre');
    if (option.barre && option.barre > option.prix) texte(ob, fmt(option.barre)); else cacher(ob, true);
    texte(q(sec, 'option-titre'), option.titre);
    texte(q(sec, 'option-desc'), option.sous_titre || '');
    var im = q(sec, 'option-img');
    if (im && option.image) { im.setAttribute('src', option.image); im.setAttribute('alt', option.titre); }
  }

  function texte(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function cacher(el, oui) {
    if (!el) return;
    if (oui) el.style.setProperty('display', 'none', 'important'); else el.style.removeProperty('display');
  }
  function retirer(el) { if (el && el.parentNode) el.parentNode.removeChild(el); }
  function bouton(b, actif) {
    if (!b) return;
    b.className = actif ? K.bouton_actif : K.bouton_inactif;
    var ov = b.querySelector('.ob-loading-overlay');
    if (ov) ov.className = actif ? K.bouton_actif_voile : K.bouton_inactif_voile;
    if (actif) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
  }

  // ---------- minuteur (Moon : localStorage, fin à heure fixe, recommence à zéro) ----------
  function lireFin() {
    try {
      var o = JSON.parse(localStorage.getItem(S.minuteur.cle) || 'null');
      if (o && typeof o.fin === 'number' && o.minutes === S.minuteur.minutes) return o.fin;
    } catch (e) { /* stockage indisponible */ }
    return null;
  }
  function ecrireFin(f) {
    try { localStorage.setItem(S.minuteur.cle, JSON.stringify({ fin: f, minutes: S.minuteur.minutes })); } catch (e) { /* idem */ }
  }
  function majMinuteur() {
    var el = q(racine, 'minuteur');
    if (!el) return;
    var duree = S.minuteur.minutes * 60000, now = Date.now();
    var fin = etat.fin || lireFin();
    if (!fin) { fin = now + duree; ecrireFin(fin); }
    if (fin <= now) { fin += Math.ceil((now - fin + 1) / duree) * duree; ecrireFin(fin); }
    etat.fin = fin;
    var s = Math.ceil(Math.max(0, fin - now) / 1000);
    var mm = String(Math.floor(s / 60)), ss = String(s % 60);
    if (mm.length < 2) mm = '0' + mm;
    if (ss.length < 2) ss = '0' + ss;
    texte(el, S.textes.minuteur.replace('{{minutes}}', mm + ':' + ss));
  }

  // ---------- ouverture / fermeture ----------
  function majOuverture() {
    var o = etat.ouvert;
    var cl = o ? K.racine_ouverte : K.racine_fermee;
    if (racine.className !== cl) racine.className = cl;
    var v = q(racine, 'voile');
    if (v) { var cv = o ? K.voile_ouvert : K.voile_ferme; if (v.className !== cv) v.className = cv; }
    racine.setAttribute('aria-hidden', o ? 'false' : 'true');
    if (o && !etat.minuteurT) etat.minuteurT = setInterval(majMinuteur, 250);
    if (!o && etat.minuteurT) { clearInterval(etat.minuteurT); etat.minuteurT = null; }
  }
  function ouvrir() {
    etat.ouvert = true;
    document.body.classList.add('overflow-hidden');
    if (!etat.cart) rafraichir({}); else rendre();
    majOuverture();
  }
  function fermer() {
    etat.ouvert = false;
    document.body.classList.remove('overflow-hidden');
    majOuverture();
  }

  // ---------- rafraîchir (une file : les demandes rapprochées n'en font qu'une) ----------
  function rafraichir(opts) {
    opts = opts || {};
    if (opts.ouvrir) etat.ouvrirApres = true;
    if (etat.enCours) { etat.enAttente = true; return etat.promesse; }
    etat.enCours = 1;
    majOccupe();
    etat.promesse = appel('cart.js').then(function (cart) {
      return opts.sansSync ? cart : synchroniser(cart);
    }).then(function (cart) {
      etat.cart = cart;
      return chargerBarres(cart).then(function () { return cart; });
    }).then(function (cart) {
      if (etat.ouvrirApres) { etat.ouvrirApres = false; etat.ouvert = true; document.body.classList.add('overflow-hidden'); }
      rendre();
      majPastille(cart);
      document.dispatchEvent(new CustomEvent('ob:panier', { detail: cart }));
      return cart;
    }).catch(function (e) {
      if (window.console) console.warn('ob-tiroir', e);
      // réseau coupé : le tiroir se redessine avec le dernier panier connu (lignes et boutons débloqués)
      try { if (etat.cart) rendre(); } catch (x) { /* rien à redessiner */ }
    })
      .then(function (c) {
        etat.enCours = 0;
        majOccupe();
        if (etat.enAttente) { etat.enAttente = false; return rafraichir({}); }
        return c;
      });
    return etat.promesse;
  }

  // pastille du panier dans l'en-tête (section du thème)
  function majPastille(cart) {
    var b = document.getElementById('cart-icon-bubble');
    if (!b) return;
    if (etat.dernierCompte === cart.item_count) return;
    etat.dernierCompte = cart.item_count;
    fetchOrigine(ROOT + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j['cart-icon-bubble']) return;
        var d = new DOMParser().parseFromString(j['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (d) b.innerHTML = d.innerHTML;
      }).catch(function () {});
  }

  // ---------- actions ----------
  function changer(key, quantite, el) {
    if (el) el.classList.add('ob-u-chargement');
    return appel('cart/change.js', { id: key, quantity: quantite }).catch(function (e) {
      if (window.console) console.warn('ob-tiroir change', e);
    }).then(function () { return rafraichir({}); });
  }

  // le paiement attend la fin d'une synchro en cours : sinon un code hors palier ou un cadeau pourrait manquer au paiement
  function occupe() { return !!(etat.enCours || etat.reseau > 0); }
  // page panier du thème : ses boutons de paiement express (Shop Pay, PayPal…) partent sans formulaire, donc sans l'attente
  // ci-dessous ; pendant une synchro ils sont inactifs (classe ob-occupe, 8 s au plus, comme l'attente du paiement)
  var occupeT = null;
  function majOccupe() {
    var o = occupe(), d = document.documentElement;
    if (d.classList.contains('ob-occupe') !== o) d.classList.toggle('ob-occupe', o);
    clearTimeout(occupeT);
    if (o) occupeT = setTimeout(function () { d.classList.remove('ob-occupe'); }, 8000);
  }
  (function () {
    var st = document.createElement('style');
    st.textContent = '.ob-occupe .cart__dynamic-checkout-buttons,.ob-occupe .additional-checkout-buttons{pointer-events:none;opacity:.5}';
    (document.head || document.documentElement).appendChild(st);
  })();
  function allerPayer(go, bouton) {
    if (!occupe()) return go();
    if (bouton) bouton.setAttribute('aria-busy', 'true');
    var debut = Date.now();
    (function attendre() {
      if (!occupe() || Date.now() - debut > 8000) return go();
      setTimeout(attendre, 100);
    })();
  }
  // page panier du thème : même attente avant « Procéder au paiement »
  document.addEventListener('submit', function (ev) {
    var f = ev.target, s = ev.submitter;
    if (!f || !f.querySelector || !occupe()) return;
    var vers = (s && s.name === 'checkout') ? s : f.querySelector('[name="checkout"]');
    if (!vers || !/\/cart(\?|$)/.test(f.getAttribute('action') || '')) return;
    ev.preventDefault();
    allerPayer(function () {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'checkout'; h.value = vers.value || '';
      f.appendChild(h);
      HTMLFormElement.prototype.submit.call(f);
    });
  }, true);

  racine.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t.closest('[data-obt="fermer"]') || t.closest('[data-obt="voile"]')) { fermer(); return; }
    var payer = t.closest('[data-obt="payer"]');
    if (payer) {
      if (payer.disabled) return;
      allerPayer(function () { window.location.href = ROOT + 'checkout'; }, payer);
      return;
    }
    var ligne = t.closest('[data-obt="ligne"]');
    if (ligne && etat.cart) {
      var key = ligne.getAttribute('data-item-key');
      var it = etat.cart.items.filter(function (x) { return x.key === key; })[0];
      if (!it) return;
      if (t.closest('[data-obt="l-moins"]')) {
        if (it.quantity > 1) changer(key, it.quantity - 1, ligne);
        return;
      }
      if (t.closest('[data-obt="l-plus"]')) {
        if (t.closest('[data-obt="l-plus"]').getAttribute('aria-disabled') === 'true') return;
        var cleP = copieParVariante[it.variant_id];
        if (cleP !== undefined && totalCle(etat.cart, cleP) >= autoriseCopie(etat.cart, cleP)) {
          // au-delà des cadeaux offerts (toutes les lignes de la clé) : comme Moon, l'unité de plus est payée (le produit
          // réel de la couleur de la ligne, prix affiché)
          ligne.classList.add('ob-u-chargement');
          appel('cart/add.js', { items: [{ id: reelDeCopie[it.variant_id] || copies[cleP].reel, quantity: 1 }] })
            .catch(function (e) { if (window.console) console.warn('ob-tiroir +', e); })
            .then(function () { return rafraichir({}); });
          return;
        }
        changer(key, it.quantity + 1, ligne);
        return;
      }
      if (t.closest('[data-obt="l-suppr"]')) {
        // un cadeau retiré par la cliente n'est pas remis par le thème
        var cle = copieParVariante[it.variant_id];
        ligne.classList.add('ob-u-chargement');
        var p = Promise.resolve();
        if (cle !== undefined) {
          var r = lireRetires(etat.cart);
          if (r[cle] || r['@' + cle]) { delete r[cle]; delete r['@' + cle]; p = appel('cart/update.js', { attributes: { _ob_cadeaux_retires: JSON.stringify(r) === '{}' ? '' : JSON.stringify(r) } }); }
        }
        p.then(function () { return changer(key, 0); });
        return;
      }
      if (t.closest('a')) { ev.preventDefault(); }
      return;
    }
    var nav = t.closest('[data-obt="prec"], [data-obt="suiv"]');
    if (nav && etat.listeUpsells) {
      var n = etat.listeUpsells.length;
      if (n > 0) etat.iu = nav.getAttribute('data-obt') === 'suiv' ? (etat.iu + 1) % n : (etat.iu === 0 ? n - 1 : etat.iu - 1);
      rendre();
      return;
    }
    var aj = t.closest('[data-obt="u-ajouter"]');
    if (aj) {
      if (aj.disabled) return;
      aj.disabled = true;
      var v = parseInt(aj.getAttribute('data-variante'), 10);
      appel('cart/add.js', { items: [{ id: v, quantity: 1, properties: { _ob_upsell: '1' } }] })
        .catch(function (e) { if (window.console) console.warn('ob-tiroir upsell', e); })
        .then(function () { return rafraichir({}); });
      return;
    }
    if (t.closest('[data-obt="option-bouton"]')) {
      ev.preventDefault();
      if (!option || !etat.cart || etat.optionEnCours) return;
      etat.optionEnCours = true;
      var lignesOpt = etat.cart.items.filter(estOption);
      var travail = lignesOpt.length
        ? lignesOpt.reduce(function (pr, it) { return pr.then(function () { return appel('cart/change.js', { id: it.key, quantity: 0 }); }); }, Promise.resolve())
        : appel('cart/add.js', { items: [{ id: option.variante, quantity: 1, properties: { _ob_option: '1' } }] });
      travail.catch(function (e) { if (window.console) console.warn('ob-tiroir option', e); })
        .then(function () { etat.optionEnCours = false; return rafraichir({}); });
      return;
    }
    if (t.closest('a.ob-cart-link--non-navigable')) ev.preventDefault();
  });

  racine.addEventListener('change', function (ev) {
    var inp = ev.target.closest('[data-obt="l-qte"]');
    if (!inp || !etat.cart) return;
    var ligne = inp.closest('[data-obt="ligne"]');
    var key = ligne && ligne.getAttribute('data-item-key');
    var v = parseInt(inp.value, 10);
    if (!key || isNaN(v) || v < 0) { rendre(); return; }
    var it = etat.cart.items.filter(function (x) { return x.key === key; })[0];
    if (it && copieParVariante[it.variant_id] !== undefined) {
      // cadeau : la copie offerte jusqu'au nombre offert (moins ce que portent les autres lignes de la clé), le surplus en
      // produit réel payé, de la couleur de la ligne (comme Moon)
      var cleQ = copieParVariante[it.variant_id];
      var aut = Math.max(0, autoriseCopie(etat.cart, cleQ) - (totalCle(etat.cart, cleQ) - it.quantity));
      if (v > aut) {
        var surplus = v - aut, reelQ = reelDeCopie[it.variant_id] || copies[cleQ].reel;
        ligne.classList.add('ob-u-chargement');
        appel('cart/change.js', { id: key, quantity: aut })
          .then(function () { return appel('cart/add.js', { items: [{ id: reelQ, quantity: surplus }] }); })
          .catch(function (e) { if (window.console) console.warn('ob-tiroir qté', e); })
          .then(function () { return rafraichir({}); });
        return;
      }
    }
    changer(key, v, ligne);
  });

  // glisser sur les upsells (Moon : 50 px à l'horizontale)
  var tx = null, ty = null;
  racine.addEventListener('touchstart', function (ev) {
    if (!ev.target.closest('[data-obt="cartes"]')) return;
    tx = ev.touches[0].clientX; ty = ev.touches[0].clientY;
  }, { passive: true });
  racine.addEventListener('touchend', function (ev) {
    if (tx === null || !etat.listeUpsells) return;
    var dx = ev.changedTouches[0].clientX - tx, dy = ev.changedTouches[0].clientY - ty;
    tx = null;
    if (Math.abs(dx) <= Math.abs(dy) || Math.abs(dx) <= 50) return;
    var n = etat.listeUpsells.length;
    if (n < 2) return;
    etat.iu = dx < 0 ? (etat.iu + 1) % n : (etat.iu === 0 ? n - 1 : etat.iu - 1);
    rendre();
  }, { passive: true });

  document.addEventListener('keyup', function (ev) { if (etat.ouvert && ev.key === 'Escape') fermer(); });

  // ---------- écoute de tous les changements du panier (thème, autres applis) ----------
  var RE_PANIER = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  window.fetch = function (entree, init) {
    var url = typeof entree === 'string' ? entree : (entree && (entree.url || entree.href)) || '';
    var h = (init && init.headers) || (entree && entree.headers);
    var interne = false;
    try { interne = h && (typeof h.get === 'function' ? h.get(INTERNE) : h[INTERNE]); } catch (e) { interne = false; }
    var p = fetchOrigine(entree, init);
    if (!interne && RE_PANIER.test(url)) {
      var ajout = /\/cart\/add/.test(url);
      // la requête du thème compte comme une synchro jusqu'au rafraîchissement qui la suit : le paiement l'attend
      etat.reseau = (etat.reseau || 0) + 1;
      majOccupe();
      var libere = function () { etat.reseau--; majOccupe(); };
      p.then(function (r) {
        setTimeout(function () { if (r && r.ok) rafraichir({ ouvrir: ajout }); libere(); }, 0);
      }, libere);
    }
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this._obUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (x._obUrl && RE_PANIER.test(String(x._obUrl))) {
      etat.reseau = (etat.reseau || 0) + 1;
      majOccupe();
      x.addEventListener('loadend', function () {
        if (x.status >= 200 && x.status < 300) rafraichir({ ouvrir: /\/cart\/add/.test(String(x._obUrl)) });
        etat.reseau--;
        majOccupe();
      });
    }
    return xs.apply(this, arguments);
  };

  // ---------- le tiroir du thème : jamais ouvert, il passe la main ----------
  function brancherTheme() {
    var CD = customElements.get('cart-drawer');
    if (!CD || CD.prototype._obBranche) return;
    CD.prototype._obBranche = true;
    CD.prototype.open = function () { ouvrir(); };
    CD.prototype.close = function () { fermer(); };
    CD.prototype.renderContents = function (etatTheme) {
      try {
        var s = etatTheme && etatTheme.sections && etatTheme.sections['cart-icon-bubble'];
        var b = document.getElementById('cart-icon-bubble');
        if (s && b) {
          var d = new DOMParser().parseFromString(s, 'text/html').querySelector('.shopify-section');
          if (d) b.innerHTML = d.innerHTML;
        }
      } catch (e) { /* pastille : mise à jour au prochain rafraîchissement */ }
      rafraichir({ ouvrir: true });
    };
  }
  if (window.customElements) {
    brancherTheme();
    customElements.whenDefined('cart-drawer').then(brancherTheme);
  }
  // l'icône panier : si le tiroir du thème est absent, on prend la main nous-mêmes
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('#cart-icon-bubble');
    if (!a || document.querySelector('cart-drawer')) return;
    ev.preventDefault();
    ouvrir();
  });

  // retour arrière servi par le cache du navigateur (depuis le paiement) : le panier a pu changer entre-temps
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) rafraichir({}); });

  window.ObTiroir = {
    ouvrir: ouvrir, fermer: fermer, rafraichir: rafraichir,
    erreur: function (msg) { if (window.console) console.warn('ob-tiroir ajout', msg); rafraichir({}); },
    _plan: plan, _offerts: cadeauxOfferts, _etat: etat
  };
  rafraichir({});
})();
